import { Form, Input, message, Modal, Select, InputNumber, Row, Col, Typography, DatePicker } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { query_type, user_role } from "../consts";
import { useCreateQuery, useGetAllClients, useGetAllFinancialYears, useGetAllQueries } from "../utils/queryUtils";
import { setReloadQuery } from "../store/action/reload";
import { useQueryClient } from "@tanstack/react-query";

var cc = require('currency-codes');
export default function CreateQuery({
    show, setShow, initialTypeValue = query_type.NORMAL,
}) {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [selectedFinancialYearId, setSelectedFinancialYearId] = useState(null);
    const [isEntitySelected, setIsEntitySelected] = useState(false);

    const [isTransactional, setIsTransactional] = useState(false);
    const currencyCodes = cc.codes();
    let { role } = useSelector((st) => st.user);

    const currencyOptions = currencyCodes.map((code) => {
        return {
            label: code,
            value: code
        };
    });

    const layout = {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
    };

    const { Option } = Select;

    // const { selected: selectedClient, all: all_clients = [] } = useSelector(st => st.client || {});
    // const { company: selectedCompany } = useSelector(st=> st.selected)
    const { name: selectedCompany } = useSelector(st => st.selected.company || {})
    // const {  } = company
    const { client: selectedClient } = useSelector(st => st.selected)
    // const { name: selectedClient } = client
    const all_clients_from_cache = useGetAllClients(selectedCompany)
    const all_clients = all_clients_from_cache?.data?.data
    // const { selected, grouped: all_fys = [] } = useSelector(st => st.fy || {});
    // const { fy : selectedFy } = useSelector(st => st.selected);
    const { fy: selectedFy } = useSelector(st => st.selected)
    const [isFinancialYearSelected, setIsFinancialYearSelected] = useState(selectedFy?._id ? true : false);
    // const { name: selectedFy } = fy

    const [selectedEntity, setSelectedEntity] = useState((all_clients?.length > 0) ? all_clients[0] : null);
    useEffect(() => {
        if (all_clients?.length > 0) {
            setSelectedEntity(all_clients[0]);
        }
    }, [all_clients]);
    const data = useGetAllFinancialYears(selectedEntity || selectedClient?._id);
    //const data = useGetAllFinancialYears(selectedClient);
    const all_fys = data?.data;
    // const all_fys = data2
    const queryData = useGetAllQueries(selectedFy?._id);
    const queries = queryData?.data?.data;
    const { mutateAsync: createQuery } = useCreateQuery();
    const queryClient = useQueryClient()
    // const { queries = [] } = useSelector(st => st.queries || {});

    const handleEntityChange = (selectedId) => {
        const selectedObject = all_clients.find(client => client._id === selectedId);

        if (selectedObject) {
            setSelectedEntity(selectedObject);
            data?.refetch();
            setIsEntitySelected(true);
            form.setFieldsValue({ financialYear: undefined });
        }
    };
    useEffect(() => {
        data.refetch()
    }, [selectedEntity])
    const handleFinancialYearChange = (value) => {
        setSelectedFinancialYearId(value);
        setIsFinancialYearSelected(true);
    }

    const handleParentQueryChange = (value) => {
    }

    async function submit(values) {
        setLoading(true);
        try {
            if (values?.cashInValue >= 0 && values?.cashInCurrency) {
                const cashIn = {
                    value: values.cashInValue,
                    currency: values.cashInCurrency,
                }
                delete values.cashInValue;
                delete values.cashInCurrency;
                values.cashIn = cashIn;
            }
            if (values?.cashOutValue >= 0 && values?.cashOutCurrency) {
                const cashOut = {
                    value: values.cashOutValue,
                    currency: values.cashOutCurrency,
                };
                delete values.cashOutValue;
                delete values.cashOutCurrency;
                values.cashOut = cashOut;
            }
            let type = user_role.COMPANY === role ? { type: "REVIEW_POINTS" } : null;
            const payload = {
                ...values,
                ...type,
                financialYear: selectedFinancialYearId ? selectedFinancialYearId : selectedFy?._id,
                descriptionV2: values.descriptionV2 ? [{ insert: values.descriptionV2 }] : []
            };
            const queriesListKey = queryClient.getQueryCache().getAll();
            const pagination = queriesListKey?.filter((dat) => dat.queryKey[0] === 'queries').map(data => {
                let pagination = data.queryKey[3];
                if (data && data?.state?.data?.data?.length >= 10) {
                    pagination += 1;
                }
                return pagination;
            }
            ).sort((a, b) => b - a)

            // setQueryCachePage(queriesListKeykey[0][3] || 1);
            const newQuery = await createQuery({ ...payload, cachefy: payload?.financialYear, cachetype: payload?.type ? payload?.type : "NORMAL", cachepage: pagination.length ? pagination[0] : 1 });
            user_role.COMPANY === role ?
                message.success('Review Points created successfully') :
                message.success('Query created successfully');
            if (newQuery) {
                setShow(false);
                setIsEntitySelected(false);
                setIsFinancialYearSelected(false);
                dispatch(setReloadQuery(true))
            }
            setIsEntitySelected(false);
            setIsFinancialYearSelected(false);
        } catch (err) {
            console.error(err);
        } finally {
            setShow(false);
            setLoading(false);
        }
    }

    return (
        <Modal open={show}
            title={user_role.COMPANY === role ? "Create Review Points" : "Create Query"}
            // title="Create Query"
            destroyOnClose
            onCancel={() => {
                form.resetFields();
                setIsTransactional(false);
                setShow(false)
            }}
            okText={user_role.COMPANY === role ? "Add Review Points" : 'Open Query'}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        submit(values);
                        form.resetFields();
                        setIsTransactional(false);
                    })
                    .catch(info => {
                        console.error('Validate Failed:', info);
                    });
            }}
            okButtonProps={{ loading: loading, htmlType: "submit" }}
            cancelButtonProps={{ loading }}
        >
            <Form layout="vertical" {...layout} onFinish={submit} form={form} initialValues={{ financialYear: selectedFy ? `${moment(selectedFy?.start).format('YYYY')} - ${moment(selectedFy?.end).format('YY')}` : undefined, client_id: selectedClient?._id }}>
                <Form.Item
                    label="Entity"
                    name="client_id"
                    initialValue={selectedClient || ((all_clients?.length > 0) ? all_clients[0]?.title : null)}
                >
                    <Select value={selectedClient || ((all_clients?.length > 0) ? all_clients[0] : null)}
                        disabled={selectedClient?._id}
                        showSearch
                        optionFilterProp="label"
                        onChange={handleEntityChange}>
                        {
                            all_clients?.map(e => (
                                <Option value={e._id} key={e._id} label={e.title}>{e.title}</Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => prevValues.client_id !== currentValues.client_id}
                >
                    {({ getFieldValue }) => {
                        // const filteredYears = all_fys?.data?.filter(fy => fy.client === getFieldValue('client_id'));
                        return (
                            <Form.Item
                                label="Financial Year"
                                name="financialYear"
                                rules={[{ required: true, message: 'Financial Year is required' }]}
                            >
                                <Select onChange={handleFinancialYearChange} disabled={!isEntitySelected || selectedFy?._id}>
                                    {all_fys?.data?.map((fy) => (
                                        <Option value={fy._id} key={fy._id}>
                                            <div style={{ display: 'flex', gap: '1rem', fontWeight: 500 }}>
                                                <span>{moment(fy.start).format('YYYY')} - {moment(fy.end).format('YY')}</span>
                                                | <span> {fy.fy_type}</span>
                                                |<span> {fy.period_type}</span>
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                        )
                    }
                        // <Form.Item
                        //     label="Financial Year"
                        //     name="financialYear"
                        //     // initialValue={selectedFy?._id}
                        //     initialValue={selectedFy}
                        // >
                        //     {/* <Select value={selectedFy?._id}> */}
                        //     <Select value={selectedFy}>
                        //         {
                        //             all_fys.find(e => e._id === getFieldValue('client_id'))?.financial_year.map(e => (
                        //                 <Option value={e._id} key={e._id}>{moment(e.start).format('YYYY')} - {moment(e.end).format('YY')}</Option>
                        //             ))
                        //         }
                        //     </Select>
                        // </Form.Item>
                    }
                </Form.Item>
                {user_role.COMPANY !== role &&
                    <Form.Item
                        label="Query Type"
                        name="type"
                        shouldUpdate={(prevValues, currentValues) => prevValues.type !== currentValues.type}
                        initialValue={initialTypeValue}
                    >
                        <Select
                            value={initialTypeValue}
                            onChange={(val) => {
                                if (val === query_type.TRANSACTIONAL) {
                                    setIsTransactional(true);
                                } else {
                                    setIsTransactional(false);
                                }
                            }}
                        >
                            <Option value={query_type.NORMAL} key={query_type.NORMAL} >Normal</Option>
                            <Option value={query_type.TRANSACTIONAL} key={query_type.TRANSACTIONAL} >Transactional</Option>
                            <Option value={query_type.REVIEW_POINTS} key={query_type.REVIEW_POINTS} >Review Points</Option>
                        </Select>
                    </Form.Item>
                }
                {
                    isTransactional && (
                        <div className='w-100'>
                            <Typography.Title level={5}>Transaction Details</Typography.Title>
                            <Row
                                justify={'space-evenly'}
                                gutter={[16, 0]}
                            >
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                >
                                    <Form.Item name='cashInValue' label='Cash In' initialValue={0} labelAlign='right' labelCol={{
                                        span: 8,
                                    }} wrapperCol={{
                                        span: 16,
                                    }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <InputNumber
                                            style={{ width: '200px' }}
                                            size='medium'
                                            placeholder='Cash In'
                                            className='mr-5'
                                        />
                                    </Form.Item>
                                </Col>
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                >
                                    <Form.Item name='cashInCurrency' label='Cash In Currency' initialValue={'AUD'} labelAlign='right' labelCol={{
                                        span: 24,
                                    }} wrapperCol={{
                                        span: 24,
                                    }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder='Select a currency'
                                            optionFilterProp='children'
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            options={currencyOptions}
                                            style={{ width: '200px' }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row
                                justify={'space-evenly'}
                                gutter={[16, 0]}
                            >
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                >
                                    <Form.Item name='cashOutValue' label='Cash Out' initialValue={0} labelAlign='right' labelCol={{
                                        span: 8,
                                    }} wrapperCol={{
                                        span: 16,
                                    }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <InputNumber
                                            style={{ width: '200px' }}
                                            size='medium'
                                            placeholder='Cash Out'
                                            className='mr-5'
                                        />
                                    </Form.Item>
                                </Col>
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                >
                                    <Form.Item name='cashOutCurrency' label='Cash Out Currency' initialValue={'AUD'} labelAlign='right' labelCol={{
                                        span: 24,
                                    }} wrapperCol={{
                                        span: 24,
                                    }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Select
                                            showSearch
                                            placeholder='Select a currency'
                                            optionFilterProp='children'
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            options={currencyOptions}
                                            style={{ width: '200px' }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                >
                                    <Form.Item name='Date' label='Date' initialValue={0} labelAlign='right' labelCol={{
                                        span: 24,
                                    }} wrapperCol={{
                                        span: 124,
                                    }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <DatePicker format="YYYY-MM-DD" style={{ width: '200px' }} />
                                    </Form.Item>
                                </Col>
                                <Col></Col>
                            </Row>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) => {
                                    return (prevValues.client_id !== currentValues.client_id) || (prevValues.financialYear !== currentValues.financialYear) || (prevValues.type !== currentValues.type)
                                }}
                            >
                                {({ getFieldValue }) =>
                                    <Form.Item
                                        label="Parent Query"
                                        name="parent_id"
                                        rules={[{ required: true, message: 'Parent query is required' }]}
                                    >
                                        <Select
                                            disabled={!isFinancialYearSelected}
                                            onChange={handleParentQueryChange}
                                        >
                                            {queries.map(e => (
                                                e.type === query_type.NORMAL ? (
                                                    <Option value={e._id} key={e._id}>{e.title}</Option>
                                                ) : null
                                            ))}
                                            {/* {
                                                queries.filter(e => e.client._id === getFieldValue('client_id') && e.financialYear === getFieldValue('financialYear') && e.type === query_type.NORMAL).map(e => (
                                                    <Option value={e._id} key={e._id}>{e.title}</Option>
                                                ))
                                            } */}
                                        </Select>
                                    </Form.Item>
                                }
                            </Form.Item>
                        </div>
                    )
                }
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true, message: 'Query title is required' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Description"
                    name="descriptionV2"
                >
                    <TextArea rows={5} />
                </Form.Item>
            </Form>
        </Modal>
    )
}